import { getCart } from 'src/api/fullDineIn.js'
import { getOrderInfo } from 'src/api/order'
import { getTable } from './common';

async function order(apiParams) {
  try {
    // eslint-disable-next-line camelcase
    const { orderId: oId, order_id } = this.$route.query;
    // eslint-disable-next-line camelcase
    const orderId = oId || order_id || this.fullDineInOrderId;
    const { data, code, success } = await getOrderInfo(apiParams)
    if (success) {
      return { key: 'order', data, success: true }
    }
    return { key: 'order', data: null, success: false }
  } catch (error) {
    console.log('[GET_ORDER_INFO]: ', error)
    return { key: 'order', data: null, success: false }
  }
}
const cart = async (apiParams) => {
  const tableNumber = getTable();
  try {
    const { data, success, code } = await getCart({ tableNumber, ...apiParams })
    // if (success) {
    return { key: 'cart', data, success: true, code }
    // }
    // return { key: 'cart', data: null, success: false }
  } catch (e) {
    return { key: 'cart', data: null, success: false }
  }
}
const reqs = {
  order,
  cart,
}
// eslint-disable-next-line no-async-promise-executor
export const updateData = (vm, key, apiParams) => new Promise(async (resolve, reject) => {
  const funs = reqs[key]
  if (funs) {
    const promiseAll = []
    // TODO: here `if` deprecated never exec
    // if (funs.constructor === Array) {
    //   funs.forEach((fun) => {
    //     promiseAll.push(fun.call(vm))
    //   })
    // } else {
    //   promiseAll.push(funs.call(vm, apiParams))
    // }
    const fullDineInTableData = JSON.parse(JSON.stringify(vm.fullDineInTableData));
    const { success, data, key: dataKey, code } = await funs.call(vm, apiParams);
    if (success) {
      fullDineInTableData[dataKey] = data
      const orderId = data?.orderId || data?.orderDetail?.orderId;
      vm.$store.dispatch('Menu/setOrderId', orderId);
    }
    vm.$store.dispatch('Menu/setFullDineInTableData', fullDineInTableData);
    resolve({ success: true, data: fullDineInTableData, code })
  } else {
    const fullDineInTableData = JSON.parse(JSON.stringify(vm.fullDineInTableData));
    resolve({ success: true, data: fullDineInTableData })
  }
})

export const resetFullDine = vm => {
  vm.$store.commit('Menu/updateFullDineInTableData', { order: {}, cart: {} });
}

